export const MANAGER_ORDERS_FR_FR = {
	orderDetailModal: {
		title: "Détails de la commande",
		orderNumber: "Commande n° #{{orderNumber}}",
		nameLabel: "Nom",
		dateLabel: "Date et heure",
		dateValue: "{{date}} à {{hour}}",
		originLabel: "Origine de la commande",
		refuseOrder: "Refuser la commande",
		acceptOrder: "Accepter la commande",
		cancelOrder: "Annuler la commande",
		readyOrder: "Commande prête",
		dispatchOrder: "Expédier la commande",
		concludeOrder: "Clôturer la commande",
		itemsTitle: "Articles de la commande",
		totalLabel: "Total",
		deliveryFeeLabel: "Frais de livraison",
		serviceFeeLabel: "Frais de service",
		additionalFeeLabel: "Frais de commande minimale",
		discountLabel: "Remise",
		discountStoreLabel: "Remise du magasin",
		discountMarketplaceLabel: "Remise iFood",
		discountKeetaLabel: "Remise Keeta",
		discountFood99Label: "Remise 99Food",
		obsLabel: "Remarque",
		obsTitle: "Remarques complémentaires",
		deliveryDetailsTitle: "Détails de livraison",
		paymentMethodLabel: "Mode de paiement",
		paymentMethodCardValue: "Carte",
		changeBackLabel: "Monnaie à rendre",
		deliveryTypeLabel: "Type de livraison",
		deliveryByStoreValue: "Livraison par le magasin",
		deliveryByPlatformValue: "Livraison par la plateforme",
		locatorLabel: "Localisateur",
		needCutleryLabel: "Couverts",
		needCutleryYes: "Le client a demandé des couverts",
		addressLabel: "Adresse",
		contactLabel: "Contact",
		cpfLabel: "CPF",
		phoneLabel: "Téléphone",
		unknownLabel: "Document inconnu",
		unknown: "Non renseigné",
		printOrder: "Imprimer la commande",
		toastAcceptTitle: "Commande acceptée",
		toastAcceptDescription:
			'La commande <bold>#{{orderNumber}}</bold> a été acceptée et se trouve dans l\'onglet "<bold>Acceptées</bold>"',
		toastReadyTitle: "Commande prête",
		toastReadyDescription:
			'La commande <bold>#{{orderNumber}}</bold> est prête et se trouve dans l\'onglet "<bold>Prêtes</bold>"',
		toastDispatchTitle: "Commande expédiée",
		toastDispatchDescription:
			'La commande <bold>#{{orderNumber}}</bold> a été expédiée et se trouve dans l\'onglet "<bold>En livraison</bold>"',
		toastConcludeTitle: "Commande terminée",
		toastConcludeDescription:
			'La commande <bold>#{{orderNumber}}</bold> a été terminée et se trouve dans l\'onglet "<bold>Terminées</bold>"',
		toastCancelTitle: "Commande annulée",
		toastCancelDescription:
			'La commande <bold>#{{orderNumber}}</bold> a été annulée et se trouve dans l\'onglet "<bold>Annulées</bold>"',
		statusMessagePlaced: "Acceptez ou refusez la commande pour continuer.",
		statusMessageConfirmed:
			"Préparez la commande et marquez-la comme prête une fois terminée.",
		statusMessageReady: "Expédiez lorsque le livreur vient récupérer la commande.",
		statusMessageReadyDineIn:
			"Finalisez la commande lorsque le client la récupère sur place.",
		statusMessageDispatched: "Finalisez la commande une fois la livraison terminée.",
	},
	refuseOrderConfirmation: {
		title: "Refuser la commande",
		message: "Êtes-vous sûr de vouloir refuser cette commande ?",
		confirmButton: "Refuser",
		secondaryMessage: "Cette action est irréversible.",
	},
};
